export default function useEmotiiFrame(value, isBipolar, start, framesLength) {
  if (isBipolar) {
    return Math.floor(start + (value * framesLength) / 2);
  }
  return Math.floor(0 + value * framesLength);
}
